import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
//import snowflake from "../images/snowflake.svg";
import snowman from "../images/snowman.png";
import snowflake from "../images_new/snowflake.svg";
import Colors from "./Colors";

const LEVELS = [
  { points: 100, color: Colors.yellowflake },
  { points: 350, color: Colors.orengeflake },
];
const BackToBenchGameLevel = ({ points }) => {
  const getProgressPercentage = (currentPoints, fromPoints, toPoints) => {
    if (currentPoints < fromPoints) return 0;
    if (currentPoints >= fromPoints && currentPoints < toPoints) {
      return ((currentPoints - fromPoints) / (toPoints - fromPoints)) * 100;
    }
    return 100;
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="row"
      gap={"2px"}
      marginTop={{ md: "-16px", xs: "8px" }}
    >
      <Box display="flex" justifyContent="center" alignItems="center">
        {/* <img src={snowman} alt="snowman" style={{ fontSize:'28px', width: "26px", height: "36px" }} /> */}
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            "& img": {
              width: { xs: "26px", md: "60px" }, // 26px for mobile, 50px for laptop
              height: { xs: "26px", md: "60px" }, // 36px for mobile, 70px for laptop
            },
          }}
        >
          <img src={snowman} alt="snowman" />
        </Box>
      </Box>
      <Box display="flex" justifyContent="center" alignItems="center">
        <LinearProgress
          variant="determinate"
          value={getProgressPercentage(points, 0, LEVELS[0].points)}
          sx={{
            height: 7,
            borderRadius: 4,
            border: "1px solid",
            borderColor: "#D3D3D3",
            background: "white",
            width: { md: "150px", xs: "46px" },
            "& .MuiLinearProgress-bar": {
              borderRadius: 5,
              backgroundColor: LEVELS[0].color,
            },
          }}
        />
      </Box>
      {LEVELS.map((level, index) => (
        <React.Fragment key={index}>
          <Box display="flex" flexDirection="column" alignItems="center">
            {/* <Box display="flex" justifyContent="center" alignItems="center" width={{ md: 42, xs: 20 }} marginTop={2}
            height={{ md: 42, xs: 20 }} borderRadius="50%" bgcolor={points >= level.points ? level.color : "gray"}>
              <img src={snowflake} alt="Snowflake" style={{ width: "70%", height: "70%", filter: "invert(100%)" }} />
            </Box> */}
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              width={{ md: 36, xs: 16 }}
              height={{ md: 36, xs: 16 }}
              borderRadius="50%"
              bgcolor={level.color}
              marginTop={"20px"}
              //  marginBottom={2}
            >
              <img
                src={snowflake}
                alt="Snowflake"
                style={{
                  width: "70%",
                  height: "70%",
                  filter: "brightness(0) invert(1)",
                }}
              />
            </Box>
            <Typography
              variant="caption"
              sx={{
                fontSize: { md: "14px", xs: "10px" },
                mt: 0.5,
                fontWeight: 500,
                color: points >= level.points ? level.color : "gray",
              }}
            >
              {level.points}
            </Typography>
          </Box>
          {index < LEVELS.length - 1 && (
            <Box display="flex" justifyContent="center" alignItems="center">
              <LinearProgress
                variant="determinate"
                value={getProgressPercentage(
                  points,
                  LEVELS[index].points,
                  LEVELS[index + 1].points,
                )}
                sx={{
                  height: 7,
                  borderRadius: 4,
                  border: "1px solid",
                  borderColor: "#D3D3D3",
                  background: "white",
                  width: { md: "150px", xs: "46px" },
                  "& .MuiLinearProgress-bar": {
                    borderRadius: 5,
                    backgroundColor: LEVELS[index + 1].color,
                  },
                }}
              />
            </Box>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default BackToBenchGameLevel;
